import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  // top: ",
        ";\n  top: 0;\n  left: 0;\n  // transition: top 0.2s;\n  background-color: #8edcff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 16px;\n  padding-right: 16px;\n  width: 100%;\n  height: ",
        "px;\n  /* background-color: ",
        "; */\n  /* background-color: transparent; */\n  /* border-bottom: solid 2px rgba(133, 133, 133, 0.1); */\n  z-index: 10;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  // position: fixed;\n  // top: 0;\n  // right: 0;\n  // transition: top 0.2s;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: row-reverse;\n  padding-left: 8px;\n  padding-right: 16px;\n  width: 30%;\n  height: ",
        "px;\n  // background-color: ",
        ";\n  z-index: 20;\n  transform: translate3d(0, 0, 0);\n  background-color: #8edcff;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  flex-grow: 1;\n  // margin-top: ",
        ";\n  transition: margin-top 0.2s;\n  transform: translate3d(0, 0, 0);\n  max-width: 100%;\n\n  ",
        " {\n    margin-left: ",
        ";\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  height: 100%;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import throttle from "lodash/throttle";
import { Overlay1 } from "../Overlay1";
import { Flex, Box } from "../Box";
import { useMatchBreakpoints } from "../../contexts";
import Panel from "./components/Panel";
import { MENU_HEIGHT, SIDEBAR_WIDTH_REDUCED, SIDEBAR_WIDTH_FULL, links2, DEFAULT_CHAINID } from "./config";
var Wrapper = styled.div.withConfig({
    componentId: "sc-932cbfd7-0"
})(_templateObject());
var StyledNav = styled.nav.withConfig({
    componentId: "sc-932cbfd7-1"
})(_templateObject1(), function(param) {
    var showMenu = param.showMenu;
    return showMenu ? 0 : "-".concat(MENU_HEIGHT, "px");
}, MENU_HEIGHT, function(param) {
    var theme = param.theme;
    return theme.nav.background;
});
var StyledNavPc = styled.nav.withConfig({
    componentId: "sc-932cbfd7-2"
})(_templateObject2(), MENU_HEIGHT, function(param) {
    var theme = param.theme;
    return theme.nav.background;
});
var BodyWrapper = styled.div.withConfig({
    componentId: "sc-932cbfd7-3"
})(_templateObject3());
var Inner = styled.div.withConfig({
    componentId: "sc-932cbfd7-4"
})(_templateObject4(), function(param) {
    var showMenu = param.showMenu;
    return showMenu ? "".concat(MENU_HEIGHT, "px") : 0;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.nav;
}, function(param) {
    var isPushed = param.isPushed;
    return "".concat(isPushed ? SIDEBAR_WIDTH_FULL : SIDEBAR_WIDTH_REDUCED, "px");
}, function(param) {
    var isPushed = param.isPushed;
    return "calc(100% - ".concat(isPushed ? SIDEBAR_WIDTH_FULL : SIDEBAR_WIDTH_REDUCED, "px)");
});
var MobileOnlyOverlay = styled(Overlay1).withConfig({
    componentId: "sc-932cbfd7-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.nav;
});
var Menu = function(param) {
    var isDark = param.isDark, links = param.links, rightSide = param.rightSide, children = param.children, currentLang = param.currentLang, setLang = param.setLang, langs = param.langs;
    // const { isXl } = useMatchBreakpoints();
    // const isMobile = isXl === false;
    var isDesktop = useMatchBreakpoints().isDesktop;
    var isMobile = isDesktop === false;
    var ref = useState(!isMobile), isPushed = ref[0], setIsPushed = ref[1];
    var ref1 = useState(true), showMenu = ref1[0], setShowMenu = ref1[1];
    var refPrevOffset = useRef(window.pageYOffset);
    useEffect(function() {
        var handleScroll = function() {
            var currentOffset = window.pageYOffset;
            var isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight;
            var isTopOfPage = currentOffset === 0;
            // Always show the menu when user reach the top
            if (isTopOfPage) {
                setShowMenu(true);
            } else if (!isBottomOfPage) {
                if (currentOffset < refPrevOffset.current) {
                    // Has scroll up
                    setShowMenu(true);
                } else {
                    // Has scroll down
                    setShowMenu(false);
                }
            }
            refPrevOffset.current = currentOffset;
        };
        if (!isMobile) {
            setIsPushed(true);
        }
        var throttledHandleScroll = throttle(handleScroll, 200);
        window.addEventListener("scroll", throttledHandleScroll);
        return function() {
            window.removeEventListener("scroll", throttledHandleScroll);
        };
    }, [
        isMobile
    ]);
    // Find the home link if provided
    var homeLink = links.find(function(link) {
        return link.label === "Home";
    });
    var chain;
    if ("object" !== "undefined" && window.localStorage) {
        if (localStorage.getItem("chainId") && localStorage.getItem("chainId") === DEFAULT_CHAINID.toString()) {
            chain = "exSat";
        }
    }
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            isMobile ? /*#__PURE__*/ _jsxs(StyledNav, {
                showMenu: showMenu,
                children: [
                    /*#__PURE__*/ _jsx(Flex, {
                        style: {
                            paddingLeft: "5px"
                        },
                        justifyContent: "center",
                        alignItems: "center",
                        onClick: function() {
                            return setIsPushed(function(prevState) {
                                return !prevState;
                            });
                        },
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/small-img/noah-logo.png",
                            width: 101,
                            alt: "logo"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                mt: "4px"
                            }),
                            rightSide
                        ]
                    })
                ]
            }) : /*#__PURE__*/ _jsx(StyledNavPc, {
                children: /*#__PURE__*/ _jsxs(Flex, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            mt: "6px"
                        }),
                        rightSide
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(BodyWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Panel, {
                        isPushed: isPushed,
                        isMobile: isMobile,
                        showMenu: showMenu,
                        isDark: isDark,
                        pushNav: setIsPushed,
                        links: chain === "exSat" ? links2 : links
                    }),
                    /*#__PURE__*/ _jsx(Inner, {
                        isPushed: isPushed,
                        showMenu: showMenu,
                        children: children
                    }),
                    /*#__PURE__*/ _jsx(MobileOnlyOverlay, {
                        show: isPushed,
                        onClick: function() {
                            return setIsPushed(false);
                        },
                        role: "presentation"
                    })
                ]
            })
        ]
    });
};
export default Menu;
